/* GRADE-TABLE-01 (owner 2026-10-09): behaviour for snippets/sz-pm-grade-table.liquid and sections/sz-pm-grade-compare.liquid.
   - Narrow screens: the "Compare … with …" selects show two grades at a time (CSS hides the other columns via .is-off
     inside a narrow container only). Product page: starts from the grade chosen in the picker and the next one up.
   - Product page: "Choose Mid" selects that grade in the picker and brings the picker into view below the header.
   - Compare page: the line links switch which line is shown (the address keeps #handle); without JS every line is
     listed and the links jump to it.
   Revert: remove the script tags in sections/sz-pm-product.liquid and sections/sz-pm-grade-compare.liquid. */
(function () {
  'use strict';
  var d = document;
  var calm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function cols(gt, a, b) {
    gt.querySelectorAll('[data-gt-col]').forEach(function (c) {
      var i = +c.getAttribute('data-gt-col');
      c.classList.toggle('is-off', i !== a && i !== b);
    });
  }

  function initTable(gt) {
    if (gt.__szGt) return; gt.__szGt = 1;
    var pick = gt.querySelector('[data-sz-gt-pick]');
    if (!pick) return;
    var sa = pick.querySelector('[data-sz-gt-a]'), sb = pick.querySelector('[data-sz-gt-b]'), n = sa.options.length;
    var a = 0, on = gt.closest('.sz-pm-pdp') && d.querySelector('.sz-pm-pdp .grade-option[aria-pressed="true"]');
    if (on) { var i = +on.getAttribute('data-grade'); if (i >= 0 && i < n) a = i; }
    var b = a + 1 < n ? a + 1 : a - 1;
    sa.value = String(a); sb.value = String(b); pick.hidden = false; gt.classList.add('is-paired'); cols(gt, a, b);
    pick.addEventListener('change', function (e) {
      var x = +sa.value, y = +sb.value;
      if (x === y) {
        if (e.target === sa) { y = x + 1 < n ? x + 1 : x - 1; sb.value = String(y); }
        else { x = y + 1 < n ? y + 1 : y - 1; sa.value = String(x); }
      }
      cols(gt, x, y);
    });
  }

  function choose(btn) {
    var opt = d.querySelector('.sz-pm-pdp .grade-option[data-variant="' + btn.getAttribute('data-sz-gt-choose') + '"]');
    if (!opt) return;
    opt.click();
    var sec = opt.closest('.grade-selector') || opt, head = d.querySelector('.final-header');
    /* the sticky header slides back in (and can sit a little lower) while the page scrolls up, so leave room for all of it */
    var cover = head ? Math.max(head.getBoundingClientRect().bottom, head.offsetHeight + 40) : 0;
    window.scrollTo({ top: sec.getBoundingClientRect().top + window.pageYOffset - cover - 16, behavior: calm ? 'auto' : 'smooth' });
    setTimeout(function () { try { opt.focus({ preventScroll: true }); } catch (e) { opt.focus(); } }, calm ? 0 : 500);
  }

  function initPage(gc) {
    var tabs = gc.querySelectorAll('[data-sz-gc-tab]'), lines = gc.querySelectorAll('[data-sz-gc-line]');
    if (!lines.length) return;
    function show(id, write) {
      var hit = null;
      lines.forEach(function (l) { if (l.id === id) hit = l; });
      if (!hit) return false;
      lines.forEach(function (l) { l.hidden = l !== hit; });
      tabs.forEach(function (t) { if (t.getAttribute('href') === '#' + id) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      if (write && history.replaceState) history.replaceState(null, '', '#' + id);
      return true;
    }
    gc.classList.add('is-tabbed');
    if (!show(decodeURIComponent(location.hash.slice(1)), false)) show(lines[0].id, false);
    gc.addEventListener('click', function (e) {
      var t = e.target.closest('[data-sz-gc-tab]'); if (!t) return;
      e.preventDefault(); show(t.getAttribute('href').slice(1), true);
    });
  }

  function boot() {
    d.querySelectorAll('[data-sz-gt]').forEach(initTable);
    var gc = d.querySelector('[data-sz-gc]'); if (gc) initPage(gc);
  }
  d.addEventListener('click', function (e) { var b = e.target.closest && e.target.closest('[data-sz-gt-choose]'); if (b) choose(b); });
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})();
